import { useOpenFeatureClientStatus, useWhenProviderReady } from "@openfeature/react-sdk";
import { ProviderStatus } from "@openfeature/web-sdk";
import { useEffect, useRef, useState } from "react";
import { OnboardingIntroExperimentVariant } from "../../../constants/onboarding-intro-experiment-variant.enum";
import { useOnboardingIntroExperimentVariant } from "../use-onboarding-intro-experiment-variant/useOnboardingIntroExperimentVariant";

export const PROVIDER_READINESS_TIMEOUT_MS = 3000;

export function useOnboardingIntroExperiment(): OnboardingIntroExperimentVariant | undefined {
  const isProviderReady = useWhenProviderReady();
  const providerStatus = useOpenFeatureClientStatus();
  const variant = useOnboardingIntroExperimentVariant();
  const latchedVariantRef = useRef<OnboardingIntroExperimentVariant | undefined>(undefined);
  const [isReadinessTimeoutExpired, setIsReadinessTimeoutExpired] = useState(false);

  useEffect(function startProviderReadinessBudget() {
    const timeoutId = setTimeout(function onReadinessTimeout() {
      setIsReadinessTimeoutExpired(true);
    }, PROVIDER_READINESS_TIMEOUT_MS);
    return function cleanup() {
      clearTimeout(timeoutId);
    };
  }, []);

  const isProviderFailed = providerStatus === ProviderStatus.ERROR || providerStatus === ProviderStatus.FATAL;
  const shouldFallBackToNone = isProviderFailed || isReadinessTimeoutExpired;
  const isVariantUnresolved = latchedVariantRef.current === undefined;

  if (isVariantUnresolved && isProviderReady) {
    latchedVariantRef.current = variant;
  } else if (isVariantUnresolved && shouldFallBackToNone) {
    latchedVariantRef.current = OnboardingIntroExperimentVariant.NONE;
  }

  return latchedVariantRef.current;
}
